<template>
    <div class="audited-by-container">
        <div
            v-for="(partner, index) in partners"
            :key="'partner-' + index"
            class="audited-by-item"
        >
            <a :href="partner.url || '#'" target="blank" rel="noreferer">
                <img
                    :src="partner.image"
                    :alt="partner.title + ' audited by'"
                />
            </a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            partners: [
                {
                    title: "AUDEFFI",
                    // image: "/images/audited-by/auddefi-2-dark.svg"
                    image: "/images/audited-by/x41-logo.svg",
                    url:
                        "https://x41-dsec.de/defi/smartcontract/smart/contract/ethereum/eth/thetanuts/solidity/security/report/2021/12/14/thetanuts.finance-smart-contract-audit/"
                }
            ]
        };
    }
};
</script>

<style lang="scss">
.audited-by-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    .audited-by-item {
        flex: 0 0 auto;
        /* width: 33.3333333333334%; */
        width: 50%;
        height: 70px;
        padding: 10px 20px;
        margin-bottom: 30px;
        display: flex;
        justify-content: center;

        @media only screen and (min-width: 768px) {
            width: 25%;
        }

        @media only screen and (min-width: 1440px) {
            height: 4.861111111111111vw;
            padding: 0.6944444444444444vw 1.3888888888888888vw;
            margin-bottom: 2.0833333333333335vw;
        }

        img {
            position: relative;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    }
}
</style>
